<script>
    export let number;
    export let theme;
    export let ref;
    export let text;
    export let groupClass;

    $: panelId = 'panel_' + number;

    let accordionClass = 'accordion-closed';

    function accordionClick() {
        if (accordionClass === 'accordion-closed') {
            accordionClass = 'accordion-open';
        }
        else {
            accordionClass = 'accordion-closed';
        }
    }

</script>

<main>
    <input type="radio" id={panelId} name="accordion-select" on:click={accordionClick}>

    <div class="panel {groupClass} {accordionClass}">
        <label class="panel-heading panel-heading" for={panelId}>{number}: {theme}</label>
        <div class="panel-block body">
            <section class="section">
                <p>
                    <span class="p-ref">{ref}</span> - <span class="p-text">{text}</span>
                </p>
            </section>
        </div>
    </div>
</main>

<style>
    /* Begin Accordion */
    input[name="accordion-select"], .panel-block {
      display: none;
    }

    label.panel-heading {
      cursor: pointer;
      display: block;
    }

    .accordion-closed .panel-block {
        display: none;
    }

    .accordion-open .body {
        display: flex;
    }

    .accordion-open .panel-heading {
        border-radius: 6px 6px 0px 0px;
    }
    /* End Accordion */

    .section {
      padding: 1rem 0.5rem;
    }

    @media (min-width: 600px) {
      .section {
          padding:  1rem 1.5rem;
      }
    }

    .panel-heading {
        border-radius: 6px 6px;
        font-size: 1.0em;
    }

    .p-ref {
        font-weight: bold;
    }

    .panel {
        font-size: 1.2rem;
        margin-bottom: 1.5em;
    }

    .panel-block {
        color: currentColor;
    }
</style>
